import React from "react";
import logo from "../../assets/aosmapslogo1.png";
import "./Header.scss";

const Header = () => {
  return (
    <header>
      <div className="header">
        <img src={logo} alt="AOS Logo" />
      </div>
    </header>
  );
};

export default Header;
